enum ImageFit {
    Fit = 'fit',
    Fill = 'fill',
}

export default ImageFit;
